import { EmployeeForm } from "./employeeForm/employee.form"
import CompanySettingsForm from "./companySettings.form"
import ForgotPasswordForm from "./forgotPassword.form"
import CreateCardFrom from "./createCard.form"

export { CompanySettingsForm, ForgotPasswordForm, EmployeeForm, CreateCardFrom }
